// extracted by mini-css-extract-plugin
export default {"introContainer":"IntroBox_introContainer__lmsl8","area":"IntroBox_area__Jea1H","intro":"IntroBox_intro__+BLuo"};